import { findIndex } from 'lodash';

function updateChapterComments(chapters, chapterId, comments) {
  const copiedChapters = Array.from(chapters);
  const updatedComments = [];
  const chapterIndex = findIndex(copiedChapters, { _id: chapterId });

  copiedChapters[chapterIndex].comments.forEach((comment) => {
    const commentIndex = findIndex(comments, { _id: comment._id });
    const updatedComment = comments[commentIndex];

    if (updatedComment) {
      updatedComments.push(updatedComment);
    } else {
      updatedComments.push(comment);
    }
  });

  copiedChapters.splice(chapterIndex, 1, { ...copiedChapters[chapterIndex], comments: updatedComments });

  return copiedChapters;
}

export default {
  updateChapterComments,
};
